import apiService from './apiService';
import { Get_Token } from 'resolvers/Get_Token';
import baseService from './apiService';

export const registerUser = async data => {
    const response = await apiService.post('/auth/signup', data);
    return response.data;
};

export const loginUser = async data => {
    const response = await apiService.post(' /login', data);
    return response.data;
};

export const getUserInfo = async () => {
    const response = await apiService.get('/auth/user', {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const refreshToken = async () => {
    const response = await apiService.post(
        '/auth/refresh',
        {},
        {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
};

export const userInvited = async (data, code) => {
    const newObject = {
        password: data.password,
        firstName: data.first_name,
        lastName: data.last_name,
        code: `${code}`
    };
    const response = await baseService.post('/auth/acceptInvite', newObject);
    return response.data;
};

export const authActivation = async data => {
    const response = await baseService.post('/auth/activation', data);
    return response.data;
};

export const validateToken = async data => {
    const response = await baseService.post('/auth/araccess', data);
    return response.data;
};

export const resendCode = async data => {
    const response = await apiService.post('/auth/resend-code', data);
    return response.data;
};
